import React, { useState, useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import cn from 'classnames';
import { Divider, Icon } from 'antd';
import PhoneNumber from '../../../../components/PhoneNumber/PhoneNumber';
import { selectedQuestionSelector } from '../../store/selectors';
import styles from './QuestionFooter.module.scss';

const Item = ({ iconType, text, className }) => {
  return (
    <div className={cn(styles.itemWrap, className)}>
      <Icon className={styles.itemIcon} type={iconType} />
      {text}
    </div>
  );
};

const QuestionFooter = () => {
  const [items, setItems] = useState([]);
  const selectedQuestion = useSelector(selectedQuestionSelector);

  useEffect(() => {
    const { createTime, phone, clientName } = selectedQuestion;
    let newItems = [];

    if (createTime) {
      newItems.push({
        iconType: 'calendar',
        text: moment(createTime).format('DD.MM.YY HH:mm'),
        className: styles['shrink-0'],
      });
    }

    if (phone) {
      newItems.push({
        iconType: 'phone',
        text: (
          <PhoneNumber
            phoneNumber={phone}
            name={clientName}
            className={styles.phone}
          />
        ),
        className: styles['shrink-0'],
      });
    }

    if (clientName) {
      newItems.push({
        iconType: 'user',
        text: clientName,
      });
    }

    setItems(newItems);
  }, [selectedQuestion]);

  return (
    <div className={styles.root}>
      {items.map((item, index) => {
        return (
          <Fragment key={item.iconType}>
            <Item {...item} />
            {index !== items.length - 1 && (
              <Divider type="vertical" className={styles.divider} />
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default QuestionFooter;
